<template>
  <div class="com-pages-sub-title">
    <div class="beset">{{title}}</div>
  </div>
</template>

<script>
  /**
   * @Class: components
   * @Module: com-pages-title
   * @Description: 组件 -页标题
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/28 15:51" ---*/
  export default {
    props: ["title"],
    name: "com-pages-title"
  }
</script>

<style lang="less">
  .com-pages-sub-title {
    width: 100%;
    padding: 2vh 0;

    .beset {
      width: 100%;
      font-size: 1.2em;
      color: #333333;
      text-align: center;
      letter-spacing: 5px;
      position: relative;

      &::before, &::after {
        content: "";
        display: block;
        width: 15%;
        border-bottom: 1px solid #dddddd;
        position: absolute;
        top: 1.3vh;
      }

      &::before {
        left: 23%;
      }

      &::after {
        right: 23%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/com-pages-sub-title.vue